/*
 * 订单确认
 * */
import request from "@utils/request";

/**
 * 通过购物车 id 获取订单信息
 * @param cartId
 * @returns {*}
 */
export function postOrderConfirm(cartId) {
  return request.post("/order/confirm", { cartId });
}

/**
 * 转入云仓
 * @param cartId
 * @returns {*}
 */
export function cr_yun(id) {
  return request.post("/order/cr_yun", { id });
}

/**
 * 云仓商品列表
 * @param cartId
 * @returns {*}
 */
export function stockList(id) {
  return request.get("/user/stockList", id);
}

/**
 * 云仓商品转增
 * @param cartId
 * @returns {*}
 */
export function transferStock(data) {
  return request.post("/user/transferStock", data);
}

/**
 * 云仓商品详情
 * @param cartId
 * @returns {*}
 */
export function stockDetails(data) {
  return request.get("/user/stockDetails", data);
}

/**
 * 云仓商品申请提货
 * @param cartId
 * @returns {*}
 */
export function stockExtract(data) {
  return request.post("/user/stockExtract", data);
}

/**
 * 库存记录
 * @param cartId
 * @returns {*}
 */
export function stocklog(data) {
  return request.get("/user/stock/log", data);
}

/**
 * 计算订单金额
 * @param key
 * @param data
 * @returns {*}
 */
export function postOrderComputed(key, data) {
  return request.post("/order/computed/" + key, data);
}

/**
 * 获取指定金额可用优惠券
 * @param price
 * @returns {*}
 */
export function getOrderCoupon(price, data) {
  return request.get("/coupons/order/" + (parseFloat(price) || 0), data);
}

/**
 * 生成订单
 * @param key
 * @param data
 * @returns {*}
 */
export function createOrder(key, data) {
  return request.post("/order/create/" + key, data || {});
}

/**
 * 订单统计数据
 * @returns {*}
 */
export function getOrderData() {
  return request.get("/order/data");
}

/**
 * 订单列表
 * @returns {*}
 */
export function getOrderList(data) {
  return request.get("/order/list", data);
}

/**
 * 取消订单
 * @returns {*}
 */
export function cancelOrder(id) {
  return request.post("/order/cancel", { id });
}

/**
 * 订单详情
 * @returns {*}
 */
export function orderDetail(id) {
  return request.get("/order/detail/" + id);
}

/**
 * 退款理由
 * @returns {*}
 */
export function getRefundReason() {
  return request.get("/order/refund/reason");
}

/**
 * 提交退款
 * @returns {*}
 */
export function postOrderRefund(data) {
  return request.post("/order/refund/verify", data);
}

/**
 * 确认收货
 * @returns {*}
 */
export function takeOrder(uni) {
  return request.post("/order/take", { uni });
}

/**
 * 删除订单
 * @returns {*}
 */
export function delOrder(uni) {
  return request.post("/order/del", { uni });
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function express(uni) {
  return request.get("order/express/" + uni);
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function payOrder(uni, paytype, from) {
  return request.post("order/pay", { uni, paytype, from });
}
/**
 * 订单核销
 * @returns {*}
 */
export function orderVerific(verify_code, is_confirm) {
  return request.post("order/order_verific", { verify_code, is_confirm });
}
/**
 * 再次下单
 * @param string uni
 *
 */
export function orderAgain(uni) {
  return request.post("order/again", { uni: uni });
}
/**
 *  换货商品列表
 * @param string uni
 *
 */
export function ware_house(data) {
  return request.get("products/hh", data);
}
/**
 *  换货
 * @param string uni
 *
 */
export function stockHh(data) {
  return request.post("user/stockHh", data);
}
/**
 *  云仓自提
 * @param string uni
 *
 */
export function stockZt(data) {
  return request.post("user/stockZt", data);
}
/**
 *  获取最近一次的课程个人信息
 * @param string uni
 *
 */
export function kcInfo(data) {
  return request.get("order/kcInfo", data);
}
/**
 *  完善课程个人信息
 * @param string uni
 *
 */
export function kcInfoUpdate(data) {
  return request.post("order/kcInfoUpdate", data);
}
